import axios from "axios";

import {
  registrySchema,
  saveRegistrySchema,
  validateRegistrySchema,
} from "@/schemas/registry";

import { getAppUrl } from "@/helper/url";

import type { House } from "@/types";

const url = `${getAppUrl()}/api/registry`;

export const getRegistry = async (
  property: Pick<House, "banco" | "numero_do_leilao">
) => {
  try {
    const response = await fetch(`${url}?${new URLSearchParams(property)}`);

    if (!response.ok) {
      throw new Error("Falha ao buscar análise de matrícula");
    }

    const data = await response.json();

    return registrySchema.parse(data);
  } catch (error) {
    console.error("Erro ao buscar análise de matrícula:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao buscar análise de matrícula"
    );
  }
};

export const validateRegistry = async (
  property: Pick<House, "banco" | "numero_do_leilao">
) => {
  try {
    const response = await fetch(`${url}/validate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(property),
    });

    if (!response.ok) {
      throw new Error("Falha ao validar matrícula");
    }

    const data = await response.json();
    return validateRegistrySchema.parse(data);
  } catch (error) {
    console.error("Erro ao validar matrícula:", error);
    throw new Error(
      error instanceof Error ? error.message : "Falha ao validar matrícula"
    );
  }
};

export const postRegistry = async (
  property: House,
  registryText: string | null
) => {
  const response = await fetch(`${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ property, registryText }),
  });

  if (!response.ok) {
    throw new Error("Falha ao salvar análise de matrícula");
  }

  const data = await response.json();

  return saveRegistrySchema.parse(data);
};

export const postRegistryRead = async (pdfUrl: string) => {
  const response = await axios.post(
    `${getAppUrl()}/api/registry/read`,
    { url: pdfUrl },
    {
      responseType: "arraybuffer",
    }
  );

  if (!response.data) {
    throw new Error("Não foi possível carregar o arquivo da matrícula");
  }

  return response.data;
};
